<!-- AI资源管理 -->
<template>
    <div>
        <!-- 查询表单 -->
        <div class="searchFlex">
            <el-form :inline="true" ref="searchForm" :model="searchForm" size="mini" label-width="90px"
                class="demo-form-inline">
                <el-form-item label="模型名称">
                    <el-input v-model.trim="searchForm.modelName" clearable placeholder="请输入模型名称"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                    <el-input v-model.trim="searchForm.role" clearable placeholder="请输入角色"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="getList">查询</el-button>
                    <el-button type="success" size="mini" @click="addRow">新增</el-button>
                </el-form-item>
            </el-form>
            <div style="margin-right:10px;">
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <!-- 表格 -->
        <div style="height:calc(100vh - 178px)">
            <vxe-table ref="aiResourceTable" id="aiResourceTable" :data="tableData" border stripe size="mini" height="auto"
                width="100%" auto-resize :column-config="{ resizable: true }" :custom-config="customConfig"
                :row-config="{ isCurrent: true }" highlight-current-row>
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column field="modelName" title="模型名称" align="center"></vxe-column>
                <vxe-column field="content" title="内容" align="center"></vxe-column>
                <vxe-column field="prompt" title="提示词" align="center" show-overflow></vxe-column>
                <vxe-column field="role" title="角色" align="center"></vxe-column>
                <vxe-column title="操作" width="160" align="center">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="success" icon="vxe-icon-edit" size="mini"
                            @click="editRow(row)">编辑</vxe-button>
                        <vxe-button mode="text" status="danger" icon="vxe-icon-delete" size="mini"
                            @click="deleteRow(row)">删除</vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <!-- 分页 -->
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize"
            :page-sizes="pageSizes" :total="pagination.total" @page-change="getList" size="mini">
        </vxe-pager>
        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="isEdit ? '编辑AI资源' : '新增AI资源'" :visible.sync="dialogVisible" width="50%"
            :before-close="dialogClose" v-dialogDrag :close-on-click-modal="false">
            <el-form ref="dialogForm" :model="dialogForm" label-width="90px" size="mini" :rules="rules">
                <el-form-item label="模型名称" prop="modelName">
                    <el-input v-model.trim="dialogForm.modelName" placeholder="请输入模型名称"></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input v-model.trim="dialogForm.content" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="提示词" prop="prompt">
                    <el-input type="textarea" v-model.trim="dialogForm.prompt" :rows="4" placeholder="请输入提示词"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="role">
                    <el-input v-model.trim="dialogForm.role" placeholder="请输入角色"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="confirmDialog">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'AIResource',
    mixins: [userProfile],
    data() {
        return {
            // 查询条件
            searchForm: {
                modelName: '',
                role: '',
            },
            // 表格数据
            tableData: [],
            // 分页参数
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            // 分页可选项
            pageSizes: [10, 20, 50, 100],
            // 弹窗是否显示
            dialogVisible: false,
            // 是否是编辑
            isEdit: false,
            // 弹窗表单数据
            dialogForm: {
                id: '',
                modelName: '',
                content: '',
                prompt: '',
                role: '',
            },
            // 校验规则
            rules: {
                modelName: [
                    { required: true, message: '请输入模型名称', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' }
                ],
                prompt: [
                    { required: true, message: '请输入提示词', trigger: 'blur' }
                ],
                role: [
                    { required: true, message: '请输入角色', trigger: 'blur' }
                ],
            },
        }
    },
    // 组件创建
    created() {
        this.getList()
    },
    methods: {
        // 查询列表
        getList() {
            this.$api.aiSysList(this.pagination.currentPage, this.pagination.pageSize, this.searchForm).then(res => {
                this.tableData = res.records
                this.pagination.total = res.total
            })
        },
        // 新增
        addRow() {
            this.isEdit = false
            this.dialogForm = {
                id: '',
                modelName: '',
                content: '',
                prompt: '',
                role: '',
            }
            this.dialogVisible = true
        },
        // 编辑 - 根据id查询详情
        editRow(row) {
            this.isEdit = true
            this.$api.aiSysGetById(row.id).then(res => {
                this.dialogForm = {
                    id: res.id,
                    modelName: res.modelName,
                    content: res.content,
                    prompt: res.prompt,
                    role: res.role,
                }
                this.dialogVisible = true
            })
        },
        // 删除
        deleteRow(row) {
            this.$confirm('是否删除该AI资源?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.aiSysDelete([row.id]).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    // 删除后刷新列表
                    this.getList()
                })
            }).catch(() => {
            });
        },
        // 关闭弹窗
        dialogClose() {
            this.dialogVisible = false
            this.$nextTick(() => {
                this.$refs.dialogForm.resetFields();
            })
        },
        // 确认新增/修改
        confirmDialog() {
            this.$refs.dialogForm.validate((valid) => {
                if (valid) {
                    // 新增
                    if (!this.isEdit) {
                        this.$api.aiSysSave(this.dialogForm).then(res => {
                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            });
                            this.dialogClose()
                            this.getList()
                        })
                    } else {
                        // 修改
                        this.$api.aiSysUpdate(this.dialogForm).then(res => {
                            this.$message({
                                type: 'success',
                                message: '修改成功'
                            });
                            this.dialogClose()
                            this.getList()
                        })
                    }
                } else {
                    return false;
                }
            })
        },
    }
}
</script>

<style lang="css">
.searchFlex {
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
